/* SCP Cart Drawer enhancements
 *
 * Handles the inline triggers introduced by snippets/cart-addons.liquid
 * (shipping calculator outlined button + coupon radio toggle) and the
 * dismiss button on snippets/scp-cart-free-shipping.liquid.
 *
 * Existing IDs/classes (#m-addons-shipping, #m-addons-coupon,
 * is="m-cart-discount", #AddressCountry, #AddressProvince, etc.) are
 * preserved so MCartDiscount and MCartAddons.calcShipping continue to
 * work without modification.
 */

(function () {
  'use strict';

  var FS_DISMISS_KEY = 'scp:cart:fs:dismissed';

  function on(el, evt, fn) {
    if (!el) return;
    el.addEventListener(evt, fn);
  }

  function setExpanded(trigger, isOpen) {
    if (!trigger) return;
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    trigger.classList.toggle('is-open', !!isOpen);
  }

  function togglePanel(panel, isOpen) {
    if (!panel) return;
    if (isOpen) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  }

  function ensureCountriesLoaded(panel) {
    if (!panel) return;
    if (panel.dataset.scpCountriesReady === '1') return;
    panel.dataset.scpCountriesReady = '1';

    var defaultSelect = panel.querySelector('#MadrressCountry select');
    if (!defaultSelect) return;

    if (typeof fetchSection !== 'function') return;
    if (!window.MinimogSettings || !window.MinimogSettings.base_url) return;

    fetchSection('country-options', { url: window.MinimogSettings.base_url })
      .then(function (html) {
        var src = html.querySelector('#AddressCountry');
        if (!src) return;
        var options = src.querySelectorAll('option');
        options.forEach(function (option) {
          defaultSelect.appendChild(option);
        });
        if (window.Shopify && window.Shopify.CountryProvinceSelector) {
          new window.Shopify.CountryProvinceSelector('AddressCountry', 'AddressProvince', {
            hideElement: 'AddressProvinceContainer',
          });
        }
        if (defaultSelect.dataset.default) {
          defaultSelect.value = defaultSelect.dataset.default;
        }
      })
      .catch(function (err) {
        console.error('[SCP Cart Drawer] country-options fetch failed', err);
      });
  }

  function initShippingTrigger(root) {
    var trigger = root.querySelector('[data-scp-trigger="shipping"]');
    var panel = root.querySelector('#m-addons-shipping');
    if (!trigger || !panel || trigger.dataset.scpInit === '1') return;
    trigger.dataset.scpInit = '1';

    on(trigger, 'click', function (event) {
      event.preventDefault();
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      var next = !isOpen;
      setExpanded(trigger, next);
      togglePanel(panel, next);
      if (next) ensureCountriesLoaded(panel);
    });
  }

  function initCouponTrigger(root) {
    var input = root.querySelector('[data-scp-coupon-input]');
    var labelWrap = root.querySelector('[data-scp-coupon-radio]');
    var panel = root.querySelector('#m-addons-coupon');
    if (!input || !labelWrap || !panel || labelWrap.dataset.scpInit === '1') return;
    labelWrap.dataset.scpInit = '1';

    function syncFromState() {
      var isOpen = !!input.checked;
      labelWrap.classList.toggle('is-active', isOpen);
      input.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      togglePanel(panel, isOpen);
    }

    on(input, 'change', syncFromState);
    syncFromState();
  }

  function isFsDismissed() {
    try {
      return sessionStorage.getItem(FS_DISMISS_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function applyFsDismissedState(root) {
    if (!isFsDismissed()) return;
    var nodes = root.querySelectorAll('[data-scp-fs]');
    nodes.forEach(function (node) {
      node.setAttribute('hidden', '');
    });
  }

  function clearFsDismiss(root) {
    try {
      sessionStorage.removeItem(FS_DISMISS_KEY);
    } catch (e) {
      /* ignore */
    }
    if (!root) return;
    var nodes = root.querySelectorAll('[data-scp-fs]');
    nodes.forEach(function (node) {
      node.removeAttribute('hidden');
    });
  }

  function initFreeShippingDismiss(root) {
    applyFsDismissedState(root);

    var buttons = root.querySelectorAll('[data-scp-fs-close]');
    buttons.forEach(function (btn) {
      if (btn.dataset.scpInit === '1') return;
      btn.dataset.scpInit = '1';
      on(btn, 'click', function () {
        var card = btn.closest('[data-scp-fs]');
        if (card) card.setAttribute('hidden', '');
        try {
          sessionStorage.setItem(FS_DISMISS_KEY, '1');
        } catch (e) {
          /* ignore */
        }
      });
    });
  }

  function initAll(root) {
    if (!root) return;
    initShippingTrigger(root);
    initCouponTrigger(root);
    initFreeShippingDismiss(root);
  }

  function bootstrap() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('cart:updated', function () {
    clearFsDismiss(document);
    initAll(document);
  });

  document.addEventListener('cart:refresh', function () {
    setTimeout(function () {
      clearFsDismiss(document);
      initAll(document);
    }, 50);
  });
})();
